module.exports = __webpack_public_path__ + "img/packing.35f425f4.gif";